import Tabs from "@/components/Tabs";
import { Path, useNavigate } from "@/router";
import { Outlet, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { FacilityDetailsHeader } from "../_components/FacilityDetailsHeader";
import { useFacilityNavLinks } from "../_utils";
import AppLayout from "@/layouts/AppLayout";
import PageTitle from "@/components/PageTitle";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import Breadcrumb from "@/components/Breadcrumb";

export default function FacilityPeopleLayout() {
  const { facilityId } = useParams();
  const { isCompactLayout: isMobile } = useIsCompactLayout();

  const location = useLocation();
  const { pathname } = location;
  const currentUrl = pathname.replace(/\/$/, "");
  const navigate = useNavigate();
  const navLinks = useFacilityNavLinks(facilityId);

  if (!facilityId) return null;

  const tabItems = [
    {
      label: "Employees",
      to: "/facilities/:facilityId/people/employees" as Path,
      active: currentUrl === `/facilities/${facilityId}/people/employees`
    },
    {
      label: "Former Employees",
      to: "/facilities/:facilityId/people/former_employees" as Path,
      active: currentUrl === `/facilities/${facilityId}/people/former_employees`
    },
    {
      label: "Governance",
      to: "/facilities/:facilityId/people/governance" as Path,
      active: currentUrl === `/facilities/${facilityId}/people/governance`
    }
  ].map(({ label, to, active }) => ({
    label,
    onClick: () => navigate(to, { params: { facilityId } }),
    active
  }));

  const renderDesktopLayout = () => (
    <>
      <PageTitle pattern={location.pathname} title={"Facilities | Facility Details"} />
      <FacilityDetailsHeader facilityId={facilityId} />
      <div className="mt-4 sm:mt-8">
        <Tabs tabItems={tabItems} />
      </div>
      <div className="flex flex-col" data-testid="tab-content">
        <Outlet />
      </div>
    </>
  );

  const renderMobileLayout = () => (
    <>
      <Breadcrumb
        compactOnly
        compactTitle="Facility People"
        backLink={{
          to: "/facilities/:facilityId",
          params: { facilityId: facilityId! }
        }}
      />
      <PageTitle pattern={location.pathname} title={"Facilities | Facility Details"} />
      <FacilityDetailsHeader facilityId={facilityId} />
      <div className="mt-4 sm:mt-8">
        <Tabs tabItems={tabItems} />
      </div>
      <div className="flex flex-col" data-testid="tab-content">
        <Outlet />
      </div>
    </>
  );

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      {isMobile ? renderMobileLayout() : renderDesktopLayout()}
    </AppLayout>
  );
}
